import React, { forwardRef } from 'react';
import './form-radio-group.scss';
export var FormRadioGroup = forwardRef(function (_a, ref) {
    var name = _a.name, attributes = _a.attributes;
    return (React.createElement("div", { className: "l-flex l-flex--wrap" }, attributes.map(function (attribute) { return (React.createElement("div", { key: attribute.id },
        React.createElement("label", { htmlFor: attribute.value, className: "c-radio-input" },
            React.createElement("input", { type: "radio", id: attribute.value, name: name, value: attribute.value, ref: ref }),
            React.createElement("span", { className: "c-radio-input__inner" },
                React.createElement("span", null, attribute.value))))); })));
});
FormRadioGroup.displayName = 'FormRadioGroup';
